import { useEffect, useState } from "react";

import { handleHideGuidedHighlighting } from "@/assignments/utils/assignmentActions";
import {
  AssignmentConfig,
  Assignment,
} from "@/types/models/Assignment.interface";
import { CONFIG_KEYS } from "@/view/AdditionalAssignmentSettings/AdditionalAssignmentSettings.constants";
import getAssignmentSetting from "@/view/utils/getAssignmentSetting";
import useAssignmentReducerContext from "@/view/utils/useAssignmentReducerContext";

import useReportContent from "../useReportContent";

const useGuidedHighlightingTeacher = () => {
  const [
    isTeacherGuidedHighlightingActive,
    setIsTeacherGuidedHighlightingActive,
  ] = useState(false);
  const { handleSubmitReport } = useReportContent();

  const { updatedAssignment: assignment, dispatch } =
    useAssignmentReducerContext() as {
      dispatch: () => void;
      updatedAssignment: Assignment;
    };

  const isGuidedHighlightingHidden = getAssignmentSetting(
    CONFIG_KEYS.hide_guided_highlighting as keyof AssignmentConfig,
    assignment,
  );

  useEffect(() => {
    setIsTeacherGuidedHighlightingActive(!isGuidedHighlightingHidden);
  }, [assignment]);

  const toggleTeacherGuidedHighlighting = (isEnabled: boolean) => {
    handleHideGuidedHighlighting(
      { hide_guided_highlighting: !isEnabled },
      dispatch,
    );
    setIsTeacherGuidedHighlightingActive(isEnabled);
  };

  const handleQuestionFeedbackThumbsDown = async (contentId: string) => {
    try {
      await handleSubmitReport({
        contentId,
        reportSource: "GuidedHighlightingQuestion",
        reaction: "thumbs_down",
      });
    } catch (error) {
      console.error("Error submitting thumbs down feedback:", error);
    }
  };

  const handleQuestionFeedbackThumbsUp = async (contentId: string) => {
    try {
      await handleSubmitReport({
        contentId,
        reportSource: "GuidedHighlightingQuestion",
        reaction: "thumbs_up",
      });
    } catch (error) {
      console.error("Error submitting thumbs up feedback:", error);
    }
  };

  return {
    isTeacherGuidedHighlightingActive,
    toggleTeacherGuidedHighlighting,
    handleQuestionFeedbackThumbsDown,
    handleQuestionFeedbackThumbsUp,
  };
};

export default useGuidedHighlightingTeacher;
